var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-certify-draw-wrapper"},[_c('p',[_vm._v("绘制证书")]),_c('canvas',{ref:"canvas",staticClass:"cerfity-draw-main",attrs:{"id":"canvas","width":"530px","height":"720px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }